<template>
  <vs-card>
    <vs-table hoverFlat stripe :data="items" search pagination max-items="15">
      <template slot="header">
        <h3>
          Étlap cikkek
        </h3>
        <vs-button radius color="success" type="gradient" icon="add" @click="addItem()"></vs-button>
      </template>
      <template slot="thead">
        <vs-th>
          Név
        </vs-th>
        <vs-th>
          Ár
        </vs-th>
        <vs-th>
          Csoport
        </vs-th>
        <vs-th>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>
            {{ tr.ItemName }}
          </vs-td>
          <vs-td>
            {{ tr.ItemPrice }}
          </vs-td>
          <vs-td>
            {{ tr.ItemCategory.CategoryName }}
          </vs-td>
          <vs-td>
            <vs-row vs-type="flex" vs-align="right" vs-justify="flex-end">
              <vs-button radius color="warning" size="small" type="gradient" icon="build"
                         @click="editItem(tr.ItemId)"></vs-button>
              <vs-button radius color="danger" size="small" type="gradient" icon="clear"
                         @click="delItem(tr.ItemId)"></vs-button>
            </vs-row>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="centerx">
      <vs-popup classContent="addItemModal" title="Új étlap cikk hozzáadása" :active.sync="addModal"
                @closemodal="closeModal()">
        <new_item v-bind:selected="selected" v-bind:menuList="menus" v-bind:categoryList="categories"
                  v-bind:addonList="addons" v-bind:labelList="labels" v-bind:dailyItem="dailyItem"
                  v-bind:itemList="items"></new_item>
      </vs-popup>
    </div>

    <div class="centerx">
      <vs-popup classContent="editItemModal" title="Étlap cikk módosítása" :active.sync="editModal"
                @closemodal="closeModal()" @updateList="updateList">
        <edit_item v-bind:selected="selected" v-bind:menuList="menus" v-bind:categoryList="categories"
                   v-bind:addonList="addons" v-bind:labelList="labels"
                   v-bind:daiilyItem="dailyItem" v-bind:itemList="items"></edit_item>
      </vs-popup>
    </div>
  </vs-card>
</template>

<script>
import {axiosInstance} from "@/main";
import new_item from "../../components/modals/new_item";
import edit_item from "../../components/modals/edit_item";

export default {
  name: "items",
  data() {
    return {
      items: [],
      menus: [],
      categories: [],
      labels: [],
      addons: [],
      dailyItem: false,
      editModal: false,
      addModal: false,
      selected: {
        ItemId: '',
        ItemName: '',
        ItemDescription: '',
        ItemPrice: '',
        ItemCategory: null,
        ItemMenu: null,
        ItemAddons: [],
        ItemLabels: [],
        DailyMenuItem: null,
        ItemFileName: null,
        ParentId: null,
        Sticky: false
      }
    }
  },
  components: {
    new_item, edit_item
  },
  methods: {
    closeModal() {
      this.editModal = false;
      this.addModal = false;
      this.getItems();
    },
    updateList() {
      this.getItems();
    },
    getItems() {
      let self = this;
      self.$vs.loading({type: 'border', text: 'Betöltés'});
      Promise.all([
        axiosInstance.get('admin/itemController.php', {
          withCredentials: true,
        }),
        axiosInstance.get('admin/menuController.php', {
          withCredentials: true,
        }),
        axiosInstance.get('admin/categoryController.php', {
          withCredentials: true,
        }),
        axiosInstance.get('admin/labelController.php', {
          withCredentials: true,
        }),
        axiosInstance.get('admin/addonController.php', {
          withCredentials: true,
        })])
          .then(results => {
            self.items = results[0].data.responseData;
            self.menus = results[1].data.responseData;
            self.categories = results[2].data.responseData;
            self.labels = results[3].data.responseData;
            self.addons = results[4].data.responseData;
            self.$vs.loading.close();
          })
          .catch((err) => {
            self.$vs.loading.close();
            if (err.response.status === 401)
              self.$root.exterminatus(err.response.data.message);
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    addItem() {
      this.selected.ItemId = '';
      this.selected.ItemName = '';
      this.selected.ItemDescription = '';
      this.selected.ItemPrice = '';
      this.selected.ItemCategory = null;
      this.selected.ItemMenu = null;
      this.selected.ItemAddons = [];
      this.selected.ItemLabels = [];
      this.selected.DailyMenuItem = 0;
      this.selected.ItemFileName = null;
      this.selected.ParentId = null;
      this.selected.Sticky = false;
      this.addModal = true;
    },
    editItem(id) {
      this.selected = {...this.items.find(elem => elem.ItemId === id)};
      this.selected.Sticky = parseInt(this.selected.Sticky);
      this.editModal = true;
    },
    delItem(id) {
      let self = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Megerősítés`,
        text: 'Valóban törölni kívánja a cikket?',
        acceptText: 'Igen',
        cancelText: 'Nem',
        accept: function () {
          axiosInstance
              .delete('admin/itemController.php?id=' + id, {withCredentials: true})
              .then((resp) => {
                self.getItems();
                self.$vs.notify({
                  title: 'Rendszerüzenet',
                  position: 'top-right',
                  text: resp.data.status === 'OK' ? 'Sikeres törlés.' : 'Sikertelen törlés. ' + resp.data.message,
                  color: resp.data.status === 'OK' ? 'success' : 'danger',
                  icon: resp.data.status === 'OK' ? 'check_box' : 'error'
                });
              })
              .catch((err) => {
                if (err.response.status === 401)
                  self.$root.exterminatus();
                else {
                  self.$vs.notify({
                    title: 'Rendszerüzenet',
                    position: 'top-right',
                    text: err.response.data.message,
                    color: 'danger',
                    icon: 'error'
                  });
                }
              });
        }
      });
    }
  },
  created() {
    this.getItems();
  }
}
</script>

<style scoped>
h3 {
  padding: 15px;
}

.vs-input {
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
}

.vs-button {
  margin: 1px 5px;
}

form {
  width: 100%;
}

.vs-icon {
  margin-left: 15px;
}

</style>